module.exports = __webpack_public_path__ + "static/media/smb3.e15c8fad.png";